import { render, staticRenderFns } from "./waitingTeams.vue?vue&type=template&id=5b4cfb06&scoped=true&"
import script from "./waitingTeams.vue?vue&type=script&lang=js&"
export * from "./waitingTeams.vue?vue&type=script&lang=js&"
import style0 from "./waitingTeams.vue?vue&type=style&index=0&id=5b4cfb06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4cfb06",
  null
  
)

export default component.exports